import JWTHelper from '@/jwt-token';
import api from '@/utils/api';
import * as Constants from '@/constants';

export default {
  name: 'UserPreferences',
  data() {
    return {
      dialog: false,
      showUserPreferences: false,
      showTooltip: '',
      defaultView: '',
      userPreferencesArray: '',
      showLoading: false,
      userId: '',
      errorMsg: ''
    };
  },
  computed: {
    isMobile() {
      return this.$mq === 'mobile';
    }
  },
  created() {
    // set the userId to use throughout this component
    this.userId = JWTHelper.user().userId;
    this.showLoading = true;
    // get the users preference for tooltips
    api.get(Constants.GET_USER_PREFERENCES_WITH_KEY_URL(this.userId, 'nursing_help'))
      .then((response) => {
        this.showTooltip = response.data.data.value;
        // if the user has access to the service logs and scheduler app
        if (JWTHelper.hasFullRights()) {
          this.getRightsForUsersWithFullAccess();
        }
      })
      .catch((error) => {
        if (error.response && error.response.data && error.response.data.message) {
          this.errorMsg = error.response.data.message;
        } else {
          this.errorMsg = error.message;
        }
      })
      .finally(() => {
        this.showLoading = false;
      });
  },
  methods: {
    /**
     * This function should only be called if the user has access to
     * the scheduler app and service log app
     * Promise 1 gets the users preference for default view
     * Promise 2 gets teh options available for default views
     */
    getRightsForUsersWithFullAccess() {
      Promise.all(
        [
          api.get(Constants.GET_USER_PREFERENCES_WITH_KEY_URL(this.userId, 'nursing_menu_default')),
          api.get(Constants.GET_USER_PREFERENCE_VALUE_OPTIONS_URL(this.userId, 'nursing_menu_default'))
        ])
        .then((response) => {
          this.defaultView = response[0].data.data.value;
          this.userPreferencesArray = response[1].data.data;
        });
    },
    toggleTooltip() {
      this.showLoading = true;
      const body = {
        userId: this.userId,
        preferenceKey: 'nursing_help',
        value: this.showTooltip === 'enabled' ? 'disabled' : 'enabled'
      };
      // update the tooltip preference
      api.put(Constants.UPDATE_USER_PREFERENCE_URL(this.userId, 'nursing_help'), body)
        .then(() => {
          // get the new tooltip preference
          return api.get(Constants.GET_USER_PREFERENCES_WITH_KEY_URL(this.userId, 'nursing_help'));
        })
        .then((response) => {
          this.showTooltip = response.data.data.value;
        })
        .catch((error) => {
          if (error.response && error.response.data && error.response.data.message) {
            this.errorMsg = error.response.data.message;
          } else {
            this.errorMsg = error.message;
          }
        })
        .finally(() => {
          // update the store with the tooltip preference
          this.$store.commit('tooltip', this.showTooltip === 'enabled');
          this.showLoading = false;
        });
    },
    setUserPreference(preference) {
      this.showLoading = true;
      const body = {
        userId: this.userId,
        preferenceKey: 'nursing_menu_default',
        value: preference
      };
      // update the preference
      api.put(Constants.UPDATE_USER_PREFERENCE_URL(this.userId, 'nursing_menu_default'), body)
        .then(() => {
          // get updated preference
          return api.get(Constants.GET_USER_PREFERENCES_WITH_KEY_URL(this.userId, 'nursing_menu_default'));
        })
        .then((response) => {
          this.defaultView = response.data.data.value;
        })
        .catch((error) => {
          if (error.response && error.response.data && error.response.data.message) {
            this.errorMsg = error.response.data.message;
          } else {
            this.errorMsg = error.message;
          }
        })
        .finally(() => {
          this.showLoading = false;
        });
    }
  },
  mounted() {
    this.dialog = true;
  },
  watch: {
    dialog() {
      if (!this.dialog) this.$emit('dialog:closed');
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/user-preferences/user-preferences.js